export default "__VITE_ASSET__BdXitm9$__"